import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MedicalRecordPainModel
} from "../../../../../../../modules/medical/medical-record/pain/api/model/medicalRecordPain.model";
import {
  LovValueSummaryFieldModule
} from "../../../../../../../modules/common/lov/lov-value/api/component/lov-value-summary-field/lov-value-summary-field.module";
import {SummaryFieldModule} from "../../../../../../../modules/core/component/summary-field/summary-field.module";
import {
  CustomDateFieldModule
} from "../../../../../../../components/common/date/custom-date/custom-date-field/custom-date-field.module";
import {ButtonModule} from "../../../../../../../modules/core/component/button/button.module";
import {
  DateSummaryFieldModule
} from "../../../../../../../modules/core/component/date/date-summary-field/date-summary-field.module";
import {MatTooltipModule} from "@angular/material/tooltip";
import {RatingModule} from "../../../../../../../modules/core/component/rating/rating.module";
import {TablerIconsModule, TablerIconsProvider} from "angular-tabler-icons";
import {ItemModule} from "../../../../../../../modules/core/component/item/item.module";
import {
  MedicalRecordPainCreateUpdateComponent,
  MedicalRecordPainSaveDialogInput, MedicalRecordPainSaveDialogResult
} from "../../../../../../../modules/medical/medical-record/pain/api/component/medical-record-pain-create-update/medical-record-pain-create-update.component";
import {DialogController} from "../../../../../../../modules/common/dialog/dialogController";
import {ButtonComponent} from "../../../../core/components/api/button/button.component";
import {IconPencil} from "angular-tabler-icons/icons";
import {
  MedicalRecordPainCreateUpdateModule
} from "../../../../../../../modules/medical/medical-record/pain/api/component/medical-record-pain-create-update/medical-record-pain-create-update.module";
import {
  MedicalPainDeleteService
} from "../../../../../../../modules/medical/medical-record/pain/impl/service/medicalPainDelete.service";
import {IconsModule} from "../../../../../../../../icons.module";
import {SummaryModule} from "../../../../../../../modules/core/component/summary/summary.module";
import {DateLabelModule} from "../../../../../../../modules/core/component/date/date-label/date-label.module";

@Component({
  selector: 'app-luna-consultation-pain-item',
  standalone: true,
  imports: [CommonModule, LovValueSummaryFieldModule, SummaryFieldModule, CustomDateFieldModule, ButtonModule, DateSummaryFieldModule, MatTooltipModule, RatingModule,
    ItemModule, ButtonComponent, MedicalRecordPainCreateUpdateModule, IconsModule, SummaryModule, DateLabelModule],
  templateUrl: './consultation-pain-item.component.html',
  providers: [
    MedicalPainDeleteService
  ]
})
export class ConsultationPainItemComponent {

  @Input() pain: MedicalRecordPainModel;
  @Input() hideButtons = false;
  @Input() titleDisplay: 'title' | 'date' = 'date';

  constructor(private dialogController: DialogController,
              public deleteService: MedicalPainDeleteService) {

  }

  update() {
    const input: MedicalRecordPainSaveDialogInput = {
      id: this.pain.id,
      startTranscription: false,
    };
    const dialog = this.dialogController.open(MedicalRecordPainCreateUpdateComponent,
        input, {title: 'Modifier la douleur', width: '95%'});
    dialog.afterClosed().toPromise().then((result: MedicalRecordPainSaveDialogResult) => {
      if (result) {
        this.pain = result.entity;
      }
    });
  }
}
